declare const window: Window & { dataLayer: Record<string, unknown>[]; }
window.dataLayer = window.dataLayer || []

const initDatalayer = (cookies: any) => {
  const dataLayerParams = {
    event: 'cookie_consent_update'
  }

  for (const [key, value] of Object.entries(cookies)) {
    if (value === true) {
      dataLayerParams[key] = 'granted'
    } else {
      dataLayerParams[key] = 'denied'
    }
  }

  window.dataLayer.push(dataLayerParams)
}

export default initDatalayer
